import { render, staticRenderFns } from "./TemplateReportBuilder.vue?vue&type=template&id=26520a8a"
import script from "./TemplateReportBuilder.vue?vue&type=script&lang=ts"
export * from "./TemplateReportBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports